"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.productBoxClick = void 0;
var _globalApiClientReact = require("@ori/global-api-client-react");
var _types = require("../types");
const productBoxClick = ({
  event,
  globalApiClient,
  language,
  customerId,
  query
}) => {
  const {
    products
  } = event.detail;
  const date = new Date();
  if (products.length > 0) {
    const signalData = {
      type: 'click',
      timeStamp: date,
      params: {
        count: 1,
        docId: products[0]?.itemCode,
        filterQueries: ['products'],
        position: 1,
        query,
        searchTime: Math.floor(date.getTime() / 1000),
        source: 'product-box-link-or-image-click',
        totalHits: 1,
        userId: customerId.toString()
      }
    };
    void (0, _globalApiClientReact.createApplicationsNavigationSignal)(globalApiClient, signalData, {
      [_types.ACCEPT_LANGUAGE]: language
    });
  }
};
exports.productBoxClick = productBoxClick;
//# sourceMappingURL=productBoxClick.js.map